import React from 'react';
import { Input, ThemeUIStyleObject, Box } from 'theme-ui';
import useStore from 'store';
import { useHasActiveBlockError } from 'store/selectors/message';
import useSaveElement from 'v1/hooks/use-save-element';

type InputProps = Parameters<typeof Input>[0];
type MarkedInputProps = InputProps & {
  containerSx?: ThemeUIStyleObject;
  srId: string;
};

export const MarkedInput = React.forwardRef<HTMLInputElement, MarkedInputProps>(
  ({ srId, containerSx, ...inputProps }, ref) => {
    const [containerRef] = useSaveElement(srId);

    return (
      <Box sx={{ position: 'relative', ...containerSx }} ref={containerRef}>
        <InputContainer srId={srId} inputProps={inputProps} />
      </Box>
    );
  }
);

function InputContainer({
  srId,
  inputProps,
}: {
  srId: string;
  inputProps: InputProps;
}) {
  const handleFieldFocused = useStore.useHandleFieldFocused();
  const hasBlockError = useHasActiveBlockError(srId);

  return (
    <Input
      // TODO: this will probably break the forms because they are using the ref
      // ref={ref}
      {...inputProps}
      onFocus={() => handleFieldFocused(srId)}
      variant={hasBlockError ? 'inputErrorActive' : 'input'}
      id={srId}
    />
  );
}
